import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import './ClientListItem.css';
import { LockIcon, SwapIcon, ParkedIcon } from '../../../../../common/icons';
import { Modal, Spin } from 'antd';
import { Promise } from 'es6-promise';

@inject('translationsStore', 'carsStore', 'lockbeatStore', 'commonStore')
@observer
export default class ClientListItem extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  toggleLockbeat(car, event) {
    event.stopPropagation();
    this.setState({ loading: true });
    new Promise((resolve, reject) => {
      if (car.lastPositionPoint && car.lastPositionPoint.coordinates) {
        return this.props.lockbeatStore
          .toggle(car.imei, car.lastPositionPoint.coordinates[1], car.lastPositionPoint.coordinates[0])
          .then(() => resolve())
          .catch(error => reject(error));
      } else {
        return this.props.lockbeatStore
          .toggle(car.imei)
          .then(() => resolve())
          .catch(error => reject(error));
      }
    })
      .then(() => {
        this.setState({ loading: false });
      })
      .catch(error => {
        const content = typeof error === 'string' ? error : JSON.stringify(error);
        Modal.error({ title: 'error setting lockbeat', content });
        this.setState({ loading: false });
      });
  }

  render() {
    const { car, lockbeatStore, commonStore } = this.props;

    const carUserName = commonStore.isFleetCustomer ? (car.driver ? `${car.driver.name} ${car.driver.surname}` : '') : car.client.fullName;

    return (
      <div className={`ClientListItem`}>
        {(this.props.showMap ?
          <Spin spinning={this.state.loading} className="lockbeatIconSpinContainer">
            <div className="lockbeatIconContainer">
              {!lockbeatStore.imeiHasNoLockbeat(car.imei) && (
                <div style={{ background: 'var(--lock-on)', borderColor: 'var(--lock-on)', color: 'white' }} onClick={event => this.toggleLockbeat(car, event)}>
                  {!this.state.loading && <LockIcon />}
                </div>
              )}
              {lockbeatStore.imeiHasNoLockbeat(car.imei) && !car.engineon && (
                <div style={{ color: 'var(--grey)', border: '1px solid var(--grey)' }} onClick={event => this.toggleLockbeat(car, event)}>
                  {!this.state.loading && <LockIcon />}
                </div>
              )}
            </div>
          </Spin>
        : <div style={{marginRight: '10px'}}/> )}
        <div>
          <div title={car.makeModel}>{car.makeModel}</div>
          <div title={carUserName}>{carUserName}</div>
        </div>
        <div>
          {/* 3rd child */}
          <div>
            <div style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{car.nickname ? car.nickname : car.plate}</div>
            {!!car.engineon && <SwapIcon style={{ color: 'var(--engine-on)', marginLeft: '5px' }} />}
            {!car.engineon && <ParkedIcon style={{ color: 'var(--lock-off)', marginLeft: '5px' }} />}
          </div>
          <div>{(car.group || '').name}</div>
        </div>
        <div>
          {car.hasWarningDtcs && <div style={{ background: 'var(--red-dtc-color)' }} />}
          {car.battery.value < 9500 && <div style={{ background: 'var(--battery-warning-color)' }} />}
          {car.hasAlarms && <div style={{ background: 'var(--alarm-color)' }} />}
          {car.hasMaintenances && <div style={{ background: 'var(--maintenance-color)' }} />}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientList/ClientListItem/ClientListItem.js